import axios from '../../axios';
import { GET_ALL_GLBOAL_IMEI, ADD_GLBOAL_IMEI, DELETE_GLBOAL_IMEI, UPDATE_GLBOAL_IMEI } from '../types';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { hasPurchase } from 'utils/util';

export const getAllGlboalIMEI = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/globalImei/all`, {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_ALL_GLBOAL_IMEI,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

export const addGlboalIMEI = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/globalImei/add`, formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_GLBOAL_IMEI, payload: res.data.data });
         setTimeout(() => {
            toast.success('IMEI added successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const checkGlobalIMEI = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/globalImei/checkExist`, formData);
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
   }
};

// export const getGLGroups = (params) => async (dispatch) => {
//   try {
//     const res = await axios.get(`${process.env.REACT_APP_ADMIN_URL}/gl/all`, {
//       params,
//     });

//     if (res.data.code === 1) {
//       dispatch({
//         type: GET_GL_GROUPS,
//         payload: res.data.data,
//         totalCount: res.data.totalCount,
//       });
//     }
//     if (res.data.code === 2) {
//       setTimeout(() => {
//         toast.warn(res.data.message);
//       }, 1000);
//     }
//   } catch (err) {
//     if (err.response?.data?.message) {
//       toast.error(err.response?.data?.message);
//     }
//   }
// };

// export const getGLGroupsAllDropdown = () => async (dispatch) => {
//   try {
//     const res = await axios.get(`${process.env.REACT_APP_ADMIN_URL}/gl/all`);

//     if (res.data.code === 1) {
//       dispatch({
//         type: GET_GL_GROUPS_ALL,
//         payload: res.data.data,
//         totalCount: res.data.totalCount,
//       });
//     }
//     if (res.data.code === 2) {
//       setTimeout(() => {
//         toast.warn(res.data.message);
//       }, 1000);
//     }
//   } catch (err) {
//     if (err.response.data.message) {
//       toast.error(err.response.data.message);
//     }
//   }
// };

// export const getGLGroupId = (id) => async (dispatch) => {
//   try {
//     const res = await axios.get(`/gl/${id}`);

//     if (res.data.code === 1) {
//       dispatch({ type: GET_GL_GROUP, payload: res.data.data });
//     }
//     if (res.data.code === 2) {
//       setTimeout(() => {
//         toast.warn(res.data.message);
//       }, 1000);
//     }
//   } catch (err) {
//     if (err.response.data.message) {
//       toast.error(err.response.data.message);
//     }
//     // console.error('Failed to add customer. Please try again.');
//   }
// };

// export const addGLGroup = (formData) => async (dispatch) => {
//   try {
//     const res = await axios.post(
//       `${process.env.REACT_APP_ADMIN_URL}/gl/add`,
//       formData,
//     );

//     if (res.data.code === 1) {
//       dispatch({ type: ADD_GL_GROUP, payload: res.data.data });
//       setTimeout(() => {
//         toast.success('GL Group added successfully!');
//       }, 1000);
//     }
//     if (res.data.code === 2) {
//       setTimeout(() => {
//         toast.warn(res.data.message);
//       }, 1000);
//     }
//   } catch (err) {
//     if (err.response.data.message) {
//       toast.error(err.response.data.message);
//     }
//   }
// };

export const updateGlboalIMEI = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/globalImei/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_GLBOAL_IMEI, payload: res.data.data });

         setTimeout(() => {
            toast.success('IMEI updated successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const deleteGlboalIMEI = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/globalImei/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_GLBOAL_IMEI, payload: { id } });
         toast.success('IMEI deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // toast.error('Failed to delete Customer. Please try again.');
   }
};

// export const updateGLGroupStatus = (data) => async (dispatch) => {
//   const res = await axios.post(
//     `${process.env.REACT_APP_ADMIN_URL}/gl/update/status`,
//     data,
//   );
//   if (res.data.code === 1) {
//     dispatch({ type: UPDATE_GL_GROUP, payload: res.data.data });
//     toast.success('Status updated successfully!');
//   }
//   if (res.data.code === 2) {
//     toast.warn(res.data.message);
//   }
//   return res.data.code;
// };

// export const getSingleLedger = (id) => async (dispatch) => {
//   try {
//     const res = await axios.get(`/gl/${id}`);
//     if (res.data.code === 1) {
//       dispatch({ type: GET_ONE_GL_GROUP, payload: res.data.data });
//     }
//   } catch (err) {
//     console.error('Failed to get item by finish item. Please try again.');
//     if (err.response.data.message) {
//       toast.error(err.response.data.message);
//     }
//   }
// };

export const getReportStockDetail = (params) => async (dispatch) => {
   try {
      const headerId = Number(params?.headerId || 0);
      delete params?.headerId;
      const res = await axios.get('/salesLineDetail/multiCompanyStock', { params });

      if (res.data.code === 1) {
         if (res.data?.data?.length > 0 && !hasPurchase(res?.data?.data, headerId)) {
            Swal.fire({
               icon: 'error',
               title: 'Oops...',
               text: 'This serial number is already in stock.',
            });
         }
         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response.data && err.response.data.code === 2) {
         const message = err.response.data.message.split('by');
         Swal.fire({
            icon: 'error',
            title: 'Oops...',
            html: message[0].replace(/\((\d+)\)/, '<b style="color: red;">($1)</b>') + ' by <br>' + message[1],
            // footer: '<a href="#">Why do I have this issue?</a>',
         });
      }

      return err.response.data;
      // console.error("Failed to get Vehicle. Please try again. :", err);
   }
};
